import React from 'react';
import Navbar from '../Navegation/Navbar';
import ContactForm from './ContactForm'
import Footer from '../Navegation/Footer';

function Contact() {

  return (
    <>
      <Navbar />
      <div style={{padding:'5%', backgroundColor:'#efeeea'}}>
        <ContactForm /> 
      </div>
      <Footer />
    </>
  );
}

export default Contact;